import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { getPlayerName, setPlayerName } from '../../util/device-id';
import { Button } from '../../components/home/buttons';
import { gameExists } from '../../firebase/firebase-db';
import { Input } from '@/components/home/input';
import { isValidGameId } from '@/util/index.ts';

export function JoinRoute() {
    const navigate = useNavigate();
    const routeGameId = (useParams<{ gameId: string }>().gameId || '').toUpperCase();
    const [name, setName] = useState(getPlayerName() || '');
    const [gameId, setGameId] = useState<string>(routeGameId);
    const [joinIsDisabled, setJoinIsDisabled] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        let isCurrent = true;

        async function checkGameId() {
            if (!isValidGameId(gameId)) {
                setJoinIsDisabled(true);
                return;
            }

            const canJoin = await gameExists(gameId);
            if (isCurrent) {
                setJoinIsDisabled(!canJoin);
            }
        }

        void checkGameId();

        return () => {
            isCurrent = false;
        };
    }, [gameId]);

    function onGameIdChange(event: React.ChangeEvent<HTMLInputElement>) {
        const text = (event.target.value?.trim()?.split('/').pop() || '').toUpperCase();
        setGameId(text);
    }

    function playerNameChanged(event: React.ChangeEvent<HTMLInputElement>) {
        const value = (event.target.value).trim();
        setPlayerName(value);
        setName(value);
    }

    function joinGame() {
        let path = `/game/${gameId}`;
        navigate(path);
    }

    return (
        <div className="w-full space-y-2 animate-slideinbottom">
            <Input autoFocus placeholder={t('join.placeholderName')} value={name} onChange={playerNameChanged} />
            <Input className="font-mono" placeholder={t('join.placeholderGameId')} value={gameId} onChange={onGameIdChange} autoCapitalize="characters" />

            <Button hotkey={{ key: 'Enter', display: '⏎', allowInInput: true }} className="w-full" disabled={joinIsDisabled || !name} onClick={joinGame}>{t('join.btnJoinGame')}</Button>
        </div>
    );
}
